<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	height="100%"
	fill="currentColor"
	version="1.1"
	viewBox="0 0 20 20"
	width="100%"
	fill-rule="evenodd"
	clip-rule="evenodd"
	class={classes('w-6 h-6 ', additionalClass)}
	><use xlink:href="#ytp-id-50" />
	<path
		d="M13.8008 4.3001C13.8008 4.04814 13.9009 3.80651 14.079 3.62835C14.2572 3.45019 14.4988 3.3501 14.7508 3.3501H16.6508C16.9027 3.3501 17.1444 3.45019 17.3225 3.62835C17.5007 3.80651 17.6008 4.04814 17.6008 4.3001V15.7001C17.6008 15.9521 17.5007 16.1937 17.3225 16.3718C17.1444 16.55 16.9027 16.6501 16.6508 16.6501H14.7508C14.4988 16.6501 14.2572 16.55 14.079 16.3718C13.9009 16.1937 13.8008 15.9521 13.8008 15.7001V4.3001Z"
	/>
	<path
		d="M8.37786 6.4782C8.1997 6.65636 8.09961 6.898 8.09961 7.14995V15.7C8.09961 15.9519 8.1997 16.1935 8.37786 16.3717C8.55602 16.5499 8.79765 16.65 9.04961 16.65H10.9496C11.2016 16.65 11.4432 16.5499 11.6214 16.3717C11.7995 16.1935 11.8996 15.9519 11.8996 15.7V7.14995C11.8996 6.898 11.7995 6.65636 11.6214 6.4782C11.4432 6.30004 11.2016 6.19995 10.9496 6.19995H9.04961C8.79765 6.19995 8.55602 6.30004 8.37786 6.4782Z"
	/>
	<path
		d="M2.67864 10.2782C2.50048 10.4564 2.40039 10.698 2.40039 10.95V15.7C2.40039 15.952 2.50048 16.1936 2.67864 16.3718C2.8568 16.5499 3.09843 16.65 3.35039 16.65H5.25039C5.50235 16.65 5.74398 16.5499 5.92214 16.3718C6.1003 16.1936 6.20039 15.952 6.20039 15.7V10.95C6.20039 10.698 6.1003 10.4564 5.92214 10.2782C5.74398 10.1001 5.50235 10 5.25039 10H3.35039C3.09843 10 2.8568 10.1001 2.67864 10.2782Z"
	/>
</svg>
